import { Book } from "lucide-react";

import { Resource } from "../../../../../types";

interface ResourcesSharedProps {
  resources: Resource[];
}

export const ResourcesShared = ({ resources }: ResourcesSharedProps) => {
  return (
    <section className="bg-white rounded-xl p-6 shadow-sm">
      <h2 className="text-xl font-semibold mb-6">Resources Shared</h2>
      <div className="space-y-4">
        {resources.map((resource: Resource, index: number) => (
          <div
            key={`resource-${index}`}
            className="flex items-start gap-4 p-4 bg-gray-50 rounded-lg"
          >
            <Book className="w-5 h-5 text-green-600 mt-1" />
            <div>
              <h3 className="font-medium">
                <a
                  href={resource.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:underline hover:text-blue-600"
                >
                  {resource.name}
                </a>
              </h3>
              <p className="text-sm text-gray-600">{resource.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
